function normalizeDuplicateRecommendationPriceRanges(scope) {
  scope.querySelectorAll(".fs-recommendation-product-price").forEach((priceEl) => {
    const text = priceEl.textContent.replace(/\s+/g, " ").trim();
    const match = text.match(/^(.+?)\s*[-–]\s*(.+)$/);

    if (!match) return;

    const firstPrice = match[1].trim();
    const secondPrice = match[2].trim();

    if (firstPrice === secondPrice) {
      priceEl.textContent = firstPrice;
    }
  });
}


function updateSwatches(colors, showMoreClick, element) {
  console.log({ colors, showMoreClick, element, msg: 'swatches' });
  const showMoreSwatch = element.querySelector(".show-more-swatches")
  if (!showMoreSwatch) return

  const totalColors = Array.isArray(colors)
    ? colors.length
    : Object.keys(colors || {}).length;

  let expanded = false;

  function updateButton() {
    const visibleSwatches = element.querySelectorAll(".color-swatch-container").length;
    const hiddenCount = Math.max(0, totalColors - visibleSwatches);
    const link = document.createElement('a')
    const url = element.querySelector(".color-swatch-container")?.dataset.altUrl;
    link.textContent = `+ ${hiddenCount}`
    link.classList.add('color-swatch-more')
    link.title = `View all ${totalColors} colors`
    if (url) {
      link.href = url;
    }

    showMoreSwatch.replaceWith(link)
  }

  updateButton();
}

function upsellHooks() {

  window.FastRecommendationWidget.registerHook("serp-product-swatches", ({ colors, swatchClick, showMoreClick, element }) => {
    let curProductElement = element.closest('.fs-upsell-cross-sell-product');
    updateSwatches(colors, showMoreClick, element);
  });


  window.FastRecommendationWidget.registerHook("upsell-cross-sell-products", ({ element, products }) => {
    normalizeDuplicateRecommendationPriceRanges(element);

    const productElements = [...element.querySelectorAll(".fs-upsell-cross-sell-product")];

    for (const productElement of productElements) {
      const productID = productElement.dataset.id;
      const data = products[productID];

      if (!data || !data.vendor) continue;

      const productInfo = productElement.querySelector(".fs-recommendation-product-info");
      if (!productInfo) continue;

      // Avoid adding it more than once
      if (productElement.querySelector(".fs-upsell-vendor-name")) continue;

      const vendorDiv = document.createElement("div");
      vendorDiv.className = "fs-upsell-vendor-name";
      vendorDiv.textContent = data.vendor;

      productInfo.insertAdjacentElement("beforebegin", vendorDiv);

    }
  });
}

if (window.FastRecommendationWidget) {
  console.log("FAST SIMON CODE 1");
  upsellHooks();
} else {
  window.addEventListener('fast-upsell-cross-sell-ready', function () {
    console.log("FAST SIMON CODE 2");
    upsellHooks();
  });
}